import { render } from "./growthCenter.vue?vue&type=template&id=48f9d760&scoped=true"
import script from "./growthCenter.vue?vue&type=script&lang=js"
export * from "./growthCenter.vue?vue&type=script&lang=js"

import "./growthCenter.vue?vue&type=style&index=0&id=48f9d760&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f9d760"]])

export default __exports__